module.exports = __webpack_public_path__ + "img/button-md-false@3x.09c755d.png";